import Vue from 'vue'
import contrycode from './contrycode'

export const checkBindPhoneOrEmail = params => {
  return Vue.fetch.post('/apiv1/account/checkBind', params)
}
/**
 *
 * @param {*} params
 */
export const getCompanyDetails = params => {
  return Vue.fetch.post('/apiv1/hr/company/findCompanyDetails', params)
}
/**
 * @description: description
 * @param {type}
 * @return:
 */
export const updateCompanyDetails = params => {
  return Vue.fetch.post('/apiv1/hr/company/updateCompanyDetails', params)
}

export const loadDateFormat = key => {
  return new Promise((resolve, reject) => {
    let formateList = [
      {
        key: 'yyyy-MM-dd',
        value: 'yyyy-MM-dd'
      },
      {
        key: 'yyyy-M-d',
        value: 'yyyy-M-d'
      },
      {
        key: 'MM-dd-yyyy',
        value: 'MM-dd-yyyy'
      },
      {
        key: 'M-d-yyyy',
        value: 'M-d-yyyy'
      },
      {
        key: 'dd-MM-yyyy',
        value: 'dd-MM-yyyy'
      },
      {
        key: 'd-M-yyyy',
        value: 'd-M-yyyy'
      },
      {
        key: 'yyyy.MM.dd',
        value: 'yyyy.MM.dd'
      },
      {
        key: 'yyyy.M.d',
        value: 'yyyy.M.d'
      },
      {
        key: 'MM.dd.yyyy',
        value: 'MM.dd.yyyy'
      },
      {
        key: 'M.d.yyyy',
        value: 'M.d.yyyy'
      },
      {
        key: 'dd.MM.yyyy',
        value: 'dd.MM.yyyy'
      },
      {
        key: 'd.M.yyyy',
        value: 'd.M.yyyy'
      },
      {
        key: 'yyyy/MM/dd',
        value: 'yyyy/MM/dd'
      },
      {
        key: 'yyyy/M/d',
        value: 'yyyy/M/d'
      },
      {
        key: 'MM/dd/yyyy',
        value: 'MM/dd/yyyy'
      },
      {
        key: 'M/d/yyyy',
        value: 'M/d/yyyy'
      },
      {
        key: 'dd/MM/yyyy',
        value: 'dd/MM/yyyy'
      },
      {
        key: 'd/M/yyyy',
        value: 'd/M/yyyy'
      }
    ]
    if (!key) {
      resolve(formateList)
    } else {
      let filterList = formateList.filter(item => {
        return item.value.toLowerCase().indexOf(key.toLowerCase()) === 0
      })
      resolve(filterList)
    }
  })
}

export const loadTimeFormat = key => {
  return new Promise((resolve, reject) => {
    let formateList = [
      {
        key: 'HH:mm:ss',
        value: 'HH:mm:ss'
      },
      {
        key: 'hh:mm:ss',
        value: 'hh:mm:ss'
      },
      {
        key: 'HH:mm:ss E',
        value: 'HH:mm:ss E'
      },
      {
        key: 'hh:mm:ss E',
        value: 'hh:mm:ss E'
      },
      {
        key: 'HH:mm:ss E a',
        value: 'HH:mm:ss E a'
      },
      {
        key: 'hh:mm:ss E a',
        value: 'hh:mm:ss E a'
      }
    ]
    if (!key) {
      resolve(formateList)
    } else {
      let filterList = formateList.filter(item => {
        return item.value.toLowerCase().indexOf(key.toLowerCase()) === 0
      })
      resolve(filterList)
    }
  })
}

export const loadLangus = that => {
  return new Promise((resolve, reject) => {
    let languages = [
      {
        key: that.$t('common.zh_cn'),
        value: 'zh-cn'
      },
      {
        key: that.$t('common.en'),
        value: 'en'
      }
    ]
    resolve(languages)
  })
}

export const loadCountry = () => {
  return new Promise((resolve, reject) => {
    resolve(contrycode)
  })
}



// WEBPACK FOOTER //
// ./src/services/companyApi.js